import mongoose from "mongoose";

const cached: {
  connection: typeof mongoose | null;
  promise: Promise<typeof mongoose> | null;
} = {
  connection: null,
  promise: null,
};

export interface DatabaseConfig {
  uri: string;
  options?: mongoose.ConnectOptions;
}

export const connectToDatabase = async (
  config: DatabaseConfig = {
    uri: process.env.MONGO_URI || "",
    options: {},
  }
): Promise<void> => {
  try {
    if (!config.uri) {
      throw new Error("MONGO_URI environment variable is not set");
    }
    if (cached.connection) {
      return;
    }
    if (!cached.promise) {
      const opts = {};
      cached.promise = mongoose.connect(config.uri, opts);
    }
    try {
      cached.connection = await cached.promise;
    } catch (e) {
      cached.promise = null;
      throw e;
    }
  } catch (error) {
    console.error("MongoDB connection error:", error);
    throw error;
  }
};

export const disconnectFromDatabase = async (): Promise<void> => {
  try {
    await mongoose.disconnect();
    cached.connection = null;
    cached.promise = null;
    console.log("Disconnected from MongoDB");
  } catch (error) {
    console.error("Error disconnecting from MongoDB:", error);
    throw error;
  }
};
